<script>
  import ViewChangeSubscription from './ViewChangeSubscription.svelte'
  import ViewConfirmChange from './ViewConfirmChange.svelte'

  export let activeMembershipQuery
  export let membership = {}
  export let inventories
  export let userCountry
  
  let selectedProduct
</script>

{#if !selectedProduct}
  <ViewChangeSubscription
    {inventories}
    {membership}
    {userCountry}
    on:cancel
    on:change={({ detail }) => selectedProduct = detail}
  />
{:else}
  <ViewConfirmChange
    selectedProduct={selectedProduct}
    {membership}
    {activeMembershipQuery}
    on:cancel={() => selectedProduct = undefined}
    on:confirm
  />
{/if}

